/**
 * Create an enum object given a keyed object.
 *
 * @param {{ [key: string]: any }} obj
 * @param {(value: any) => string} repr - returns string representation of the given value
 */
export const create = (obj, repr = v => v) => {
    const keys = Object.keys(obj);
    const reversed = Object.entries(obj)
        .reduce((acc, [k, v]) => ({...acc, [repr(v)]: k}), {});
    const _enum = {
        getValue (v) {
            return this[this[v]];
        },
        keys () { return keys },
        values () { return keys.map(k => obj[k]); },
        map (rev = false) {
            return {...rev ? reversed : obj};
        },
        [Symbol.iterator] () {
            let i = 0;
            return {
                next: () => {
                    if (i < keys.length) {
                        return {value: keys[i++], done: false};
                    }
                    else return {done: true};
                }
            };
        }
    };
    Object.entries(obj).forEach(([k, v]) => {
        _enum[_enum[repr(v)] = k] = v;
    });
    return _enum;
}

export const fromValues = obj => create(obj)
export const fromObjects = obj => create(obj, ({value}) => value)
